import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'pipelines-panel-notes',
  imports: [],
  templateUrl: './pipelines-panel-notes.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pipelines-panel-notes.component.scss','../../pipelines-table.component.scss']
})
export class PipelinesPanelNotesComponent {
  @Input() detail:any

}
